import { render, staticRenderFns } from "./CanshopCar.vue?vue&type=template&id=6f382676&scoped=true&"
import script from "./CanshopCar.vue?vue&type=script&lang=js&"
export * from "./CanshopCar.vue?vue&type=script&lang=js&"
import style0 from "./CanshopCar.vue?vue&type=style&index=0&id=6f382676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f382676",
  null
  
)

export default component.exports